module.exports = __webpack_public_path__ + "img/winerackdog21.b6ca1dc6.jpg";